import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const verifyAccessToken = createAsyncThunk('auth/verifyAccessToken', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/verify-access-token');
    const { status, data } = response.data;
    if (status === 'Success') {
      return { 
        isAuthenticated: true, 
        userType: data.user_type,
        user_first_name: data.first_name, 
        user_last_name: data.last_name,
        user_email: data.email,
        user_account_type: data.account_type,
        user_super_admin: data.super_admin,
        latest_week: data.latest_week,
        latest_day: data.latest_day,
        user_details:data.user_details
      };
    } else {
      return rejectWithValue('Authentication failed');
    }
  } catch (error) {
    return rejectWithValue('Error verifying access token');
  }
});

const protectSlice = createSlice({
  name: 'protect',
  initialState: {
    isAuthenticated: null,
    userType: null,
    user_details:{},
    isLoading: true,
    error: null,
    user_first_name:null,
    user_last_name:null,
    user_email:null,
    user_account_type:null,
    user_super_admin:null,
    latest_week:1,
    latest_day:1
  },
  reducers: {
    logout: (state) => {
      state.isAuthenticated = null;
      state.userType = null;
      state.isVerified = null;
      state.isLoading = true;
      state.user_first_name = null;
      state.user_last_name = null;
      state.user_email = null;
      state.user_account_type = null;
      state.user_super_admin = null;
      state.user_details ={};
      state.latest_day = 1;
      state.latest_week = 1;
    },
    loginAsUserFunc:(state) => {
      state.isAuthenticated=true;
      state.userType='client';
    },
    loginAsAdminFunc:(state) => {
      state.isAuthenticated=true;
      state.userType='admin';
    },
    updateWeekAndDay: (state, action) => {
      state.latest_day = action.payload.latest_day;
      state.latest_week = action.payload.latest_week;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyAccessToken.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.isAuthenticated;
        state.userType = action.payload.userType;
        state.isLoading = false;
        state.user_first_name = action.payload.user_first_name;
        state.user_last_name = action.payload.user_last_name;
        state.user_email = action.payload.user_email;
        state.user_account_type = action.payload.user_account_type;
        state.user_super_admin = action.payload.user_super_admin;
        state.user_details = action.payload.user_details;
        state.latest_week = action.payload.latest_week;
        state.latest_day = action.payload.latest_day;
      })
      .addCase(verifyAccessToken.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.userType = null;
        state.isLoading = false;
        state.error = action.payload;
        state.user_first_name = null;
        state.user_last_name = null;
        state.user_email = null;
        state.user_account_type = null;
        state.user_super_admin = null;
        state.latest_week = 1;
        state.latest_day = 1;
        state.user_details = {};
      });
  },
});

export const { logout, loginAsAdminFunc, loginAsUserFunc, updateWeekAndDay } = protectSlice.actions;
export default protectSlice.reducer;